import { Box, Skeleton, Typography } from '@mui/material';
import { ProductGroupsTreeView } from '../ProductGroupsTree';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { ProductGroupCount, ProductGroup } from '@retail/products/types';
import { CollapsibleFilterField } from './CollapsibleFilterField';
import { productGroupTreeHeight, productGroupTreeScrollSx } from './productGroupTreeScrollSx';

interface Props {
  productGroups?: ProductGroupCount[];
  selectedProductGroup: ProductGroup | null;
  showProductGroups: boolean;
  noGroupsMessage?: string;
  /** Max height of the scrollable tree when the filter is open. */
  treeHeight?: number;
  toggleShowProductGroups: () => void;
  selectProductGroup: (productGroup: string | null) => void;
  getCount?: (productGroup: ProductGroup) => number | undefined;
}

export function ProductGroupFilter({
  productGroups,
  selectedProductGroup,
  showProductGroups,
  noGroupsMessage,
  treeHeight = productGroupTreeHeight,
  toggleShowProductGroups,
  selectProductGroup,
  getCount,
}: Props) {
  const t = useMyAssortmentTFunction();

  return (
    <CollapsibleFilterField
      label={t('myAssortment.filters.productGroup')}
      open={showProductGroups}
      onToggle={toggleShowProductGroups}
      gap={0}
    >
      {!productGroups ? (
        <Skeleton height={50} />
      ) : productGroups.length === 0 ? (
        noGroupsMessage && (
          <Typography pl={1} variant="body3">
            {noGroupsMessage}
          </Typography>
        )
      ) : (
        <Box sx={productGroupTreeScrollSx(treeHeight)}>
          <ProductGroupsTreeView
            productGroups={productGroups}
            selectedProductGroup={selectedProductGroup}
            selectProductGroup={selectProductGroup}
            getCount={getCount}
          />
        </Box>
      )}
    </CollapsibleFilterField>
  );
}
